import React, { useState, useEffect } from "react";
import Button from '../../../../button/button';
import Modal from '../../../../modal/modal';
import PaySVG from '../../../../icons/pay';
import BankSVG from '../../../../icons/bank';
import CardSVG from '../../../../icons/card';
import './paymentConfirm.scss';
import PrintReceipt from "./PrintReceipt/PrintReceipt";
import Axios from 'axios'
import PaymentMethod from "./paymentMethod/PaymentMethod";
import SplitPay from "./SplitPay/SplitPay";
import Tooltip from "../../../../Tooltip/Tooltip";
import CloseSVG from "../../../../icons/close";
const PaymentConfirm = (props) => {
    //state to open print receipt
    const [isOpenPrintReceipt, setIsOpenPrintReceipt] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState({
        receptionist_id: '',
        receptionist_subsidiary_id: '',
        students_payments: [],
        paymentMethod: [],
        amount_payed: 0,
        exchange_rate: ''
    })
    const [formatPaymentD, setFormatPaymentD] = useState([])
    const [totalAmount, setTotalAmount] = useState(0);
    //state to split pay
    const [isSplitPay, setIsSplitPay] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState([])
    const [receiptResultData, setReceiptResultData] = useState({})
    const [isSplitRemaining, setIsSplitRemaining] = useState(false)
    const subsidiaryToRegisterPaid = localStorage.getItem('receptionSubsidiarySession')
    useEffect(() => {
        if (props.isOpen) {
            setPaymentDetails(prev => ({
                ...prev, students_payments: props.concepts,
                receptionist_id: props.usr.employee_id,
                receptionist_subsidiary_id: subsidiaryToRegisterPaid,
                paymentMethod: paymentMethod,
                exchange_rate: props.exchange

            }))
        }
    }, [paymentMethod])

    useEffect(() => {
        if (paymentDetails.students_payments.length > 0) {
            let concepts = paymentDetails.students_payments;
            const formattedData = concepts.map(student => (
                {
                    id: student.id_student,
                    name: student.name,
                    concepts: [
                        // Formateo de tuition si no está vacío
                        ...(student.concepts_to_pay.tuition && student.concepts_to_pay.tuition.length > 0 ? student.concepts_to_pay.tuition.map(t => ({
                            name: t.isTuition ? "Colegiatura" : "Abono",
                            amount: t.amount && !isNaN(t.amount) ? t.amount.toFixed(2) : "0.00", // Asegúrate de que sea un número válido
                        })) : []),

                        // Formateo de books si no está vacío
                        ...(student.concepts_to_pay.books && student.concepts_to_pay.books.length > 0 ? student.concepts_to_pay.books.map(b => ({
                            name: `${b.name}`,
                            amount: b.price && !isNaN(b.price) ? b.price.toFixed(2) : "0.00", // Asegúrate de que sea un número válido
                        })) : []),

                        // Formateo de inscription si no está vacío
                        ...(student.concepts_to_pay.inscription && typeof student.concepts_to_pay.inscription.amount === "number" ? [{
                            name: "Inscripción",
                            amount: !isNaN(student.concepts_to_pay.inscription.amount) ? student.concepts_to_pay.inscription.amount.toFixed(2) : "0.00",
                        }] : []),
                    ]
                }));


            // Actualizamos el estado con los datos formateados
            setFormatPaymentD(formattedData);
            // Calculate the total amount to pay (in MXN)
            // Calculamos el total a partir de los conceptos de cada alumno
            const computedTotal = formattedData.reduce((total, student) => {
                const studentTotal = student.concepts.reduce((sum, concept) => {
                    return sum + parseFloat(concept.amount);
                }, 0);
                return total + studentTotal;
            }, 0);

            setTotalAmount(computedTotal);
        }
    }, [paymentDetails]);



    // Total amount in dollars (for display only)
    const dllsChange = props.exchange ? (totalAmount / props.exchange).toFixed(2) : "0.00";

    const handleConfirmPayment = async () => {
        // Función para mostrar alertas
        const showAlert = (msg, type) => {
            const id = Math.floor(Math.random() * 100) + 1;
            props.setArrayAlerts(oldArray => [{ id, message: msg, type }, ...oldArray]);
            props.setIsVisibleAlert(true);
        };
        if (paymentMethod.length > 1) {
            if (isSplitRemaining) {
                return showAlert("Verifique que la cantidad a pagar sea la correcta", 'info');
            }
            // Verifica si hay efectivo MXN para dar cambio
            const hasZeroMethodPaymentAmount = paymentMethod.some(
                (m) => m.amount === '' || m.amount === '0.00' || m.amount === 0
            );
            if (hasZeroMethodPaymentAmount) {
                return showAlert("Verifique nuevamente las cantidades de los metodos de pago, no puedo haber 0", 'danger');
            }
        } else {
            if (paymentMethod.length > 0) {
                let method = paymentMethod[0]
                if ('rawAmount' in method) {
                    if (method.amount === '' || method.amount === '0.00' || method.amount === 0) {
                        return showAlert("Verifique nuevamente las cantidades de los metodos de pago", 'danger');
                    }
                    if (paymentMethod.length === 1) {
                        return showAlert("Presione el boton <- regresar si desea solamente utilizar 1 solo metodo de pago", 'danger');
                    }
                }
            }
        }
        const postResponseRegisterStudentsPayment = await PostRegisterStudentsPayment(paymentDetails);
        if (postResponseRegisterStudentsPayment && postResponseRegisterStudentsPayment.status) {
            const { status, message } = postResponseRegisterStudentsPayment;



            const infoStatuses = [201, 202, 203, 204, 205, 206, 207, 208, 210, 211, 212];
            switch (status) {
                case 200:
                    let receiptId = postResponseRegisterStudentsPayment.result.receipt_id;
                    const receiptResult = await GetPaymentReceiptByID(receiptId)
                    let statusR = receiptResult.status
                    switch (statusR) {
                        case 200:
                            setReceiptResultData(receiptResult.result)
                            setIsOpenPrintReceipt(true);
                            showAlert(message, 'success');
                            break;

                        default:
                            break;
                    }
                    break;
                case 209:
                    showAlert(message, 'danger');
                    break;

                default:
                    if (infoStatuses.includes(status)) {
                        showAlert(message, 'info');
                    }
                    break;
            }
        }
    };

    const GetPaymentReceiptByID = async (receipt_id) => {
        try {
            const res = await Axios.post(
                process.env.REACT_APP_API_URL + "getPaymentReceiptByID/",
                { receipt_id },
                {
                    headers: {
                        "x-access-token": localStorage.getItem("token"),
                    },
                }
            );
            return res.data;
        } catch (error) {
            console.error("Error recibiendo recibos de pago:", error);
            return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
        }
    };

    const PostRegisterStudentsPayment = async (payment_detail) => {
        try {
            const res = await Axios.post(
                process.env.REACT_APP_API_URL + "postRegisterStudentsPayment/",
                { payment_detail },
                {
                    headers: {
                        "x-access-token": localStorage.getItem("token"),
                    },
                }
            );
            return res.data;
        } catch (error) {
            console.error("Error registrando pagos:", error);
            return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
        }
    };
    const handleClosePrintReceipt = () => {
        setIsOpenPrintReceipt(false);
    }
    const handleSplitPay = () => {
        setIsSplitPay(true);
    }
    const handleCloseSplitPay = () => {
        setIsSplitPay(false);
    }
    const handleCloseModal = () => {
        if (Object.keys(receiptResultData).length !== 0) {
            props.onClose()
            props.cleanFields()
        } else {
            props.onClose()
        }
    }
    return (
        <>
            <Modal isOpen={props.isOpen} onClose={props.onClose} overlayClick={false}>
                <button className="modal-close-button" onClick={handleCloseModal}>
                    <CloseSVG/>
                </button>
                <div className='confirm-pay-container'>
                    <div className='confirm-pay'>
                        <div className='summary-container'>
                            <h1 className='title-1'>Resumen de pago</h1>
                            <ul className='summary-list'>
                                {formatPaymentD.map((student) => (
                                    <li key={student.id} className='summary-student-section'>
                                        <div className='summary-student-container'>
                                            <h1 className='title-3'>{student.name}</h1>
                                            <ul>
                                                {student.concepts.map((concept, index) => (
                                                    <li key={index}>
                                                        <p>{concept.name}</p>
                                                        <p>${concept.amount}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <div className='summary-amount'>
                                <p className='amount-mxn'>
                                    Importe total: ${totalAmount.toFixed(2)}
                                </p>
                                <p className='amount-dlls'>
                                    Importe en dolar: ${dllsChange}
                                </p>
                            </div>
                        </div>

                        {/* Payment method section */}
                        <div className="payment-method-container">
                            {!isSplitPay ?
                                <>
                                    <Tooltip text={'Utiliza esta opción para cobrar el importe con dos o mas métodos de pago'}>
                                        <Button text={'Dividir pago'} onClick={handleSplitPay} />
                                    </Tooltip>
                                    <PaymentMethod
                                        totalAmount={totalAmount}
                                        exchange={props.exchange}
                                        setPaymentMethod={setPaymentMethod}
                                    />
                                </> :
                                <>
                                    <Tooltip text={'Pagar con un solo método de pago'}>
                                        <Button text={'Un solo pago'} onClick={handleCloseSplitPay} />
                                    </Tooltip>

                                    <SplitPay
                                        onClose={handleCloseSplitPay}
                                        totalAmount={totalAmount}
                                        exchange={props.exchange}
                                        setPaymentMethod={setPaymentMethod}
                                        stateRemaining={setIsSplitRemaining}
                                    ></SplitPay>
                                </>}
                        </div>
                    </div>
                    <div className='confirm-buttons-section'>
                        <Button backgroundColor="blue" disabled={Object.keys(receiptResultData).length === 0} text="Imprimir Recibo" onClick={() => setIsOpenPrintReceipt(true)} />
                        <Tooltip text={'Regresar a la ventana anterior'}>
                            <Button backgroundColor="red" text={Object.keys(receiptResultData).length === 0 ? "Atras" : "Realizar otro pago"} onClick={handleCloseModal} />
                        </Tooltip>
                        <Tooltip text={'Al finalizar el pago no se puede editar o cancelar'}>
                            <Button backgroundColor="blue" disabled={Object.keys(receiptResultData).length !== 0} text="Finalizar pago" onClick={handleConfirmPayment} />
                        </Tooltip>
                    </div>
                </div>

            </Modal>
            {isOpenPrintReceipt && <PrintReceipt isOpen={true} onClose={handleClosePrintReceipt} receiptData={receiptResultData} />}

        </>
    );
};

export default PaymentConfirm;